import localStorage from '@utils/localstorage'
const user = {
  state: {
    token: '',
    expireTime: '',
    userName: ''
  },
  mutations: {
    setToken: (state, val) => {
      localStorage.save('USER_TOKEN', val)
      state.token = val
    },
    setExpireTime: (state, val) => {
      localStorage.save('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setUserName: (state, val) => {
      localStorage.save('USER_NAME', val)
      state.userName = val
    }
  },
  actions: {
    setToken({
      commit
    }, token) {
      commit('setToken', token)
    },
    getToken({
      state
    }) {
      return state.token
    },
    setExpireTime({
      commit
    }, expireTime) {
      commit('setExpireTime', expireTime)
    },
    getExpireTime({
      state
    }) {
      return state.expireTime
    },
    setUserName({
      commit
    }, userName) {
      commit('setUserName', userName)
    },
    getUserName({
      state
    }) {
      return state.userName
    }
  }
}

export default user
